import { render } from "./couponClaimPopup.vue?vue&type=template&id=31dc5ca6&scoped=true"
import script from "./couponClaimPopup.vue?vue&type=script&lang=js"
export * from "./couponClaimPopup.vue?vue&type=script&lang=js"

import "./couponClaimPopup.vue?vue&type=style&index=0&id=31dc5ca6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dc5ca6"]])

export default __exports__